export const getDefaultPostText = (query) => {

    let postDefaultInput = ''
    if (query.startsWith('#') || query.startsWith('@')) {
        postDefaultInput = query
    }

    return postDefaultInput;
}